import { useRef, useMemo } from "react";
import { Route, Routes } from "react-router-dom";
import PropTypes from "prop-types";
import usePermissions from "hooks/usePermissions";

import SettingsWrapper from "./SettingsWrapper";
import settingsRoutes from "./settingsRoutes";
import "./settings.scss";

const CommonSettings = function ({ currentLocale, handleLocaleChange }) {
  const { permissions } = usePermissions();
  const { user_type } = JSON.parse(permissions || "{}");

  const settingsWrappperRef = useRef();
  const handleSetPermissions = (newPermissions) => {
    if (settingsWrappperRef?.current?.setPermissions) {
      settingsWrappperRef.current.setPermissions(newPermissions);
    }
  };

  const routeProps = {
    YourDetails: { currentLocale, handleLocaleChange, setPermissions: handleSetPermissions },
  };
  const filteredRoutes = useMemo(() => settingsRoutes.filter(({ userType }) => userType.includes(user_type)), [user_type]);

  document.title = "Settings";

  return (
    <SettingsWrapper ref={settingsWrappperRef}>
      <Routes>
        {filteredRoutes.map(({ path, name, component: Component }) => (
          <Route key={path} path={path} element={<Component {...routeProps[name]} />} />
        ))}
      </Routes>
    </SettingsWrapper>
  );
};

CommonSettings.propTypes = {
  currentLocale: PropTypes.string,
  handleLocaleChange: PropTypes.func,
};

CommonSettings.defaultProps = {
  currentLocale: "en",
  handleLocaleChange: null,
};

export default CommonSettings;
